import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import EzDialog from "../../../common/EzDialog";
import EzControlledCalendarWithFloatingLabel from "../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import EzControlledDropDownWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../utils/form/form-utils";
import { formatDate, DATE_STRATEGY } from "../../../utils/date";
import { reservationStatusDD, reportTypeDD } from "../AffiliateReport/constant";

const GenerateInvoiceDialog = (props) => {
  const { visible, onHide, onGenerate, affiliateDD, isGenerating } = props;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      affiliateId: null,
      startDate: null,
      endDate: null,
      dueDate: null,
      status: null,
      type: null,
    },
  });

  useEffect(() => {
    if (!visible) {
      reset();
    }
  }, [visible, reset]);

  const getFormErrorMessage = (fieldName) => {
    return errors[fieldName] ? errors[fieldName].message : "";
  };

  const onSubmit = (data) => {
    const payload = {
      affiliateId: data.affiliateId ? [data.affiliateId] : [],
      startDate: data.startDate ? formatDate(data.startDate, DATE_STRATEGY.DATE_ISO) : null,
      endDate: data.endDate ? formatDate(data.endDate, DATE_STRATEGY.DATE_ISO) : null,
      dueDate: data.dueDate ? formatDate(data.dueDate, DATE_STRATEGY.DATE_ISO) : null,
      status: data.status || null,
      type: data.type || null,
      userId: localStorage.getItem("userId"),
    };
    onGenerate(payload);
  };

  return (
    <EzDialog
      header="Generate Affiliate Invoice"
      visible={visible}
      onHide={onHide}
      width="700px"
      height="auto"
      maximizable={false}
      footer={
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}
        >
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={onHide}
            disabled={isGenerating}
          />
          <Button
            label="Generate"
            icon="pi pi-check"
            className="p-button-raised"
            onClick={handleSubmit(onSubmit)}
            disabled={isGenerating}
            loading={isGenerating}
          />
        </div>
      }
    >
      <div className="form-demo" style={{ paddingBottom: 0 }}>
        <form className="p-fluid">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <EzControlledDropDownWithFloatingLabel
                name="affiliateId"
                control={control}
                rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                optionLabel="name"
                optionValue="id"
                options={affiliateDD || []}
                isError={errors["affiliateId"]}
                errorMsg={getFormErrorMessage("affiliateId")}
                label="Affiliate"
                labelClassName="ml-2"
                shouldFilter={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <EzControlledCalendarWithFloatingLabel
                name="startDate"
                control={control}
                label="Start Date"
                maxDate={new Date(2090, 0, 1)}
                rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                isError={errors.startDate}
                errorMsg={getFormErrorMessage("startDate")}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <EzControlledCalendarWithFloatingLabel
                name="endDate"
                control={control}
                label="End Date"
                maxDate={new Date(2090, 0, 1)}
                rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                isError={errors.endDate}
                errorMsg={getFormErrorMessage("endDate")}
              />
            </Grid>

            <Grid item xs={12}>
              <EzControlledCalendarWithFloatingLabel
                name="dueDate"
                control={control}
                label="Due Date"
                rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                isError={errors.dueDate}
                errorMsg={getFormErrorMessage("dueDate")}
                maxDate={new Date(2090, 0, 1)}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <EzControlledDropDownWithFloatingLabel
                name="type"
                control={control}
                rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                optionLabel="name"
                optionValue="id"
                options={reportTypeDD}
                isError={errors["type"]}
                errorMsg={getFormErrorMessage("type")}
                label="Type"
                labelClassName="ml-2"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <EzControlledDropDownWithFloatingLabel
                name="status"
                control={control}
                rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                optionLabel="name"
                optionValue="id"
                options={reservationStatusDD}
                isError={errors["status"]}
                errorMsg={getFormErrorMessage("status")}
                label="Status"
                labelClassName="ml-2"
              />
            </Grid>
          </Grid>
        </form>
      </div>
    </EzDialog>
  );
};

export default GenerateInvoiceDialog;
